import { landEtikett } from '../components/vendors/laender'

/**
 * market.js — Marktcode → Anzeigename „English name (ISO)" (Welle 3 PR 4, §4.3).
 *
 * 🔴 Warum die Anzeige den Namen NICHT aus `shp_markets.name` nimmt: die Spalte
 * ist **gemischt deutsch/englisch** (gemessen in Produktion, 2026-10-06) —
 * „Österreich"/„Schweiz" neben „Germany"/„Denmark". Ein durchgereichter Name
 * stuende halb deutsch in einer englischen Oberflaeche. Der englische Name
 * kommt deshalb aus `Intl.DisplayNames(['en'])` (ueber `landEtikett`), also aus
 * dem Marktcode.
 *
 * 🔴 `SU` ist der **Shopify**-Marktcode der Schweiz, nicht ISO-3166-alpha-2
 * (das waere `CH`). `backend/market_utils.py::resolve_market` loest ueber genau
 * diesen Code auf, und `backend/tests/test_versandkenntnis_in_der_empfehlung.py`
 * baut eine Empfehlung mit `"market_code": "SU"` — die Schweiz kommt als `SU`
 * aus den Marktdaten. Das ist die EINZIGE Sonderregel; `AT/CZ/DE/DK/ES/FR`
 * sind bereits ISO-3166-alpha-2 und gehen unveraendert durch.
 *
 * `EU` und `INT` sind keine Laender und bekommen eigene Etiketten.
 *
 * Muster und Wiederverwendung: `components/vendors/laender.js::landEtikett`
 * macht `${name} (${code})` mit derselben `Intl.DisplayNames`-Instanz — hier
 * wird sie wiederverwendet, nicht dupliziert.
 *
 * Anlass: `docs/superpowers/plans/2026-10-06-ux-feinschliff-welle-3.md` §4.3.
 */

/** Shopify-Marktcode → ISO-3166-1-alpha-2. Heute belegt: nur `SU → CH`. */
const SHOPIFY_ZU_ISO = { SU: 'CH' }

/** Wertemengen, die KEINE Laender sind, mit eigenem Etikett. */
const SONDER = { EU: 'European Union', INT: 'International' }

/**
 * Anzeigename zu einem Marktcode.
 *
 * @param {string} marketCode  der Marktcode (`SU`, `DE`, `EU`, `INT`, …)
 * @param {string} fallbackName  was bei leerem/unbekanntem Code erscheint
 * @returns {string}  „Switzerland (CH)" / „Germany (DE)" / „European Union" /
 *                    „International", sonst `fallbackName`
 */
export function marketLabel(marketCode, fallbackName = '') {
  const raw = String(marketCode ?? '').trim().toUpperCase()
  if (!raw) return fallbackName || ''
  if (SONDER[raw]) return SONDER[raw]
  const iso = SHOPIFY_ZU_ISO[raw] || raw
  const etikett = landEtikett(iso)
  // `landEtikett` liefert den Code allein zurueck, wenn der Browser keinen
  // Namen kennt — dann ist `fallbackName` die bessere Auskunft.
  return etikett === iso ? (fallbackName || iso) : etikett
}
